export default "__VITE_ASSET__ipmeEWjp__"